     <div>
     
        <!-- <app-login *ngIf="isLoginPage"></app-login>
        <app-register *ngIf="isRegisterPage"></app-register> -->
       
        <ng-container *ngIf="!isLoginPage && !isRegisterPage">
      <app-header  (isRegisterPage)="changeRegisterstatus($event)" (isLoginPage)="changeLoginstatus($event)" (headericonSelected)="onMenuIconSelected($event)"></app-header>
      <app-headersection  *ngIf="showComponents && isLandingPage"></app-headersection>
      <app-pdftool *ngIf="showComponents && isLandingPage" (iconSelected)="onMenuIconSelected($event)" ></app-pdftool>
      
      <app-document-upload [cIsWeblink]="isWebLink" (idetifiredataEmitter)="onMenuIconSelected($event)" (DIconselected)="onMenuIconSelected($event)"></app-document-upload>

      <app-solutionwrapper *ngIf="showComponents && isLandingPage"></app-solutionwrapper>
      <app-anothersolutionwrapper *ngIf="showComponents && isLandingPage"></app-anothersolutionwrapper>
      <app-trustedusers *ngIf="showComponents && isLandingPage"></app-trustedusers>
      <app-terms-n-conditions *ngIf="termsPage"></app-terms-n-conditions>
      <app-privacy-n-policy *ngIf="privacyPage"></app-privacy-n-policy>
      <app-blog-tool *ngIf="blogPage"></app-blog-tool>
    </ng-container>
      <!-- <router-outlet *ngIf="isLandingPage"></router-outlet> -->
      <router-outlet *ngIf="isLandingDetailsPage"></router-outlet>
    </div>
    <ng-container *ngIf="!isLoginPage && !isRegisterPage && isLandingPage">   
<app-footer *ngIf="showComponents"></app-footer>
<a id="back-to-top" class="back-to-top" role="button"><img src="assets/images/top.png" alt="" /></a>
</ng-container>

  